module.exports = __webpack_public_path__ + "img/Lesson-cn.9b6d98c9.png";